import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/yasal/iletisim")({
  beforeLoad: () => {
    throw redirect({ to: "/" });
  },
  component: () => null,
});
